import React, { createContext, useContext, useReducer } from 'react'

import { ITagState, ITagAction, ETagActionType, ITag } from 'models'

const initialTagsState: ITagState = {
	available: [],
	selected: [],
}

const TagsContext: React.Context<any> = createContext(null)
const reducer: React.Reducer<any, any> = (
	state: ITagState,
	action: ITagAction,
) => {
	switch (action.type) {
		case ETagActionType.populate:
			return {
				...state,
				available: action.tags,
			}
		case ETagActionType.select:
			return {
				...state,
				selected:
					action.tag && [...state.selected].concat([action.tag]),
				// available: [...state.available].filter(
				// 	item => action.tag && item.id !== action.tag.id,
				// ),
				// selected:
				// 	action.tag && [...state.selected].concat([action.tag]),
			}
		case ETagActionType.deselect:
			return {
				...state,
				selected: [...state.selected].filter(
					item => action.tag && item.id !== action.tag.id,
				),
				// available:
				// 	action.tag && [...state.available].concat([action.tag]),
			}
		default:
			return state
	}
}
export const TagsProvider: React.FunctionComponent<{ selected: ITag[] }> = ({
	children,
	selected,
}) => (
	<TagsContext.Provider
		value={useReducer(reducer, { ...initialTagsState, selected })}
	>
		{children}
	</TagsContext.Provider>
)
export const useTagsState = () => useContext(TagsContext)
